import { action, observable } from 'mobx';
import user from '../../App/stores/UserStore';
import { get } from '../../../services/request';

const byDefaultDoNothing = () => {};
const overviewColumns = (t, onClick = byDefaultDoNothing) => [
  {
    key: 'itemNumber',
    name: t('Number'),
    fieldName: 'itemNumber',
    minWidth: 50,
    maxWidth: 130,
    onColumnClick: onClick,
    isSorted: false,
    isSortedDescending: false,
    isResizable: true,
  },
  {
    key: 'title',
    name: t('Title'),
    fieldName: 'title',
    minWidth: 200,
    maxWidth: 450,
    onColumnClick: onClick,
    isSorted: false,
    isSortedDescending: false,
    isResizable: true,
  },
  {
    key: 'status',
    name: t('Status'),
    fieldName: 'status',
    minWidth: 200,
    maxWidth: 300,
    isSorted: false,
    isSortedDescending: false,
    isResizable: true,
  },
  {
    key: 'agentName',
    name: t('Agent'),
    fieldName: 'agentName',
    minWidth: 100,
    maxWidth: 200,
    onColumnClick: onClick,
    isSorted: false,
    isSortedDescending: false,
    isResizable: true,
  },
  {
    key: 'startAt',
    name: t('Start date'),
    fieldName: 'startAt',
    minWidth: 100,
    maxWidth: 150,
    onColumnClick: onClick,
    isSorted: true,
    isSortedDescending: true,
    isResizable: true,
  },
  {
    key: 'pendingOffersCount',
    name: t('Pending offers'),
    fieldName: 'pendingOffersCount',
    minWidth: 90,
    maxWidth: 90,
    onColumnClick: onClick,
    isSorted: false,
    isSortedDescending: false,
    isResizable: true,
  },
];

class ListingsStore {
  @observable items = [];
  @observable columns = [];
  @observable fetching = true;
  @observable loaded = false;

  constructor(user) {
    this.user = user;
  }

  @action sortBy(field) {
    const index = this.columns.findIndex((c) => c.key === field);
    const column = this.columns[index];
    this.items = this.items.sortBy(field, column.isSortedDescending);

    this.columns = this.columns.map((c, i) => {
      if (i !== index) {
        c.isSorted = false;
        c.isSortedDescending = false;
      } else {
        c.isSorted = true;
        c.isSortedDescending = !c.isSortedDescending;
      }
      return c;
    });
  }

  @action load() {
    this.fetching = true;
    get('/api/v1/sales', this.user.accessToken).then(
      this.loadListingsOverviewSuccess,
      this.loadListingsOverviewError
    );
  }

  @action initColumns(t, onClick) {
    this.columns = overviewColumns(t, onClick);
  }

  @action.bound loadListingsOverviewSuccess(data) {
    this.items = data.objects.sortBy('startAt', false);
    this.fetching = false;
    this.loaded = true;
  }

  @action.bound loadListingsOverviewError(error) {
    this.fetching = false;
  }
}

const listings = new ListingsStore(user);

export default listings;
export { ListingsStore };



// WEBPACK FOOTER //
// ./src/app/containers/Overview/stores/ListingsStore.js